<template>
  <!-- Container -->
  <section class="container-fluid main-container mt-5 mb-5">
    <progress-bar
      v-if="!isKBInternal"
      :defaultSite="defaultSite"
      :step2Active="isActive"
    ></progress-bar>
    <div class="row col-12 col-lg-10 mx-auto bg-light">
      <div class="col-12 col-md-8">
        <main role="main">
 

              <!------------ cards ------------>
        <section v-if="showQuotes.length > 0" class="row">
            <div v-for="(quote) in showQuotes" class="col col-12 col-lg-4 mb-3" v-bind:value="quote.COVERTYPE" :key="quote.COVERTYPE">
              <div class="card h-100" :class="quote.COVERTYPE === tripDetails.quoteType && 'shadow border border-primary'" @click="changeSelectedQuote(quote.COVERTYPE)">
              <div class="tf-vue-bg-grey-dark d-flex justify-content-center align-items-center p-3">
                  <h2 class="fs-5">{{ quote.COVERTYPE === 'SINGLEG' && 'Trailfinders Single Trip policy' 
                                   || quote.COVERTYPE === 'ANNUALG' && 'Trailfinders Annual Multi-Trip policy' 
                                   || quote.COVERTYPE === 'BACKPACKER' && 'Trailfinders Backpacker policy'}}
                  </h2>
                </div>
                <div class="card-body tf-vue-bg-grey-light p-3 d-flex flex-column align-items-center" 
                >
                <span v-if="quote.PREMIUM === '0' ||quote.PREMIUM === 0"
                class="fs-1 fw-bold">
                  N/A
                </span>
                  <span v-else class="fs-1 fw-bold"
                    >{{ defaultSite.symbol }}{{ quote.PREMIUM }}</span
                  >
                  <!-- form -->
                  <form novalidate @submit="submitQuote(quote.COVERTYPE)"
                                         name="singleForm">
                    <section class="row justify-content-center">
                      <div v-if="quote.COVERTYPE === 'ANNUALG'">
                      <div v-if="tripDetails.totalAdults > 1">
                            <annual-policy-modal
                              :over90="over90Days"
                              :premium = "quote.PREMIUM"
                              @terms-accepted="submitAnnual"
                            >
                            </annual-policy-modal>
                          </div>
                          <div v-else>
                            <button
                              v-if="!isKBInternal"
                              :disabled="quote.PREMIUM === '0'|| quote.PREMIUM === 0"
                              type="submit"
                              class="btn btn-primary w-100 rounded-0"
                            >
                              Buy
                            </button>
                          </div>
                      
                          <p
                        v-if="over90Days"
                        variant="danger"
                        class="text-center mt-2 over90"
                      >
                        Trailfinders Annual Insurance can only be purchased
                        within 90 days of travel.
                      </p>
                      <p
                        v-if="annualGroupSizeError && quote.COVERTYPE ==='ANNUALG'"
                        variant="danger"
                        class="text-center mt-2 over90"
                      >
                      Maximum two adults per policy.
                      </p>
                      <p
                        v-if="annualDurationError && quote.COVERTYPE ==='ANNUALG'"
                        variant="danger"
                        class="text-center mt-2 over90"
                      >
                      Maximum duration per trip is 70 days.
                      </p>
                   
                    <hr />
                    <p class="tf-vue-cover fw-bold">
                      Our Annual Multi-Trip policy covers you for
                      <strong>unlimited trips worldwide</strong> up to 70 days,
                      <strong>for a whole year</strong>.
                    </p>
                      </div>
                      <div v-else>
                        <button
                          v-if="!isKBInternal"
                          :disabled= "quote.PREMIUM === '0'"
                          type="submit"
                          class="btn btn-primary w-100 rounded-0"
                        >
                          Buy
                        </button>
                        <p
                        v-if="overBackpackerAges && quote.COVERTYPE ==='BACKPACKER'"
                        variant="danger"
                        class="text-center mt-2 over90"
                      >
                      Maximum age for Backpacker Travel Insurance is 30.
                      </p>
                      <p
                        v-if="backpackerYoungAgeError && quote.COVERTYPE ==='BACKPACKER'"
                        variant="danger"
                        class="text-center mt-2 over90"
                      >
                      Minimum age for Backpacker Travel Insurance is 14.
                      </p>
                      <p
                        v-if="backpackerGroupSizeError && quote.COVERTYPE ==='BACKPACKER'"
                        variant="danger"
                        class="text-center mt-2 over90"
                      >
                      Maximum two people per policy.
                      </p> 
                      </div>
                    </section>
                    <hr />
                    <div class="form-group">
                      <div class="radio-group less-margin">

                        <!-- WINTER SPORTS -->
                        <div v-if="quote.COVERTYPE !== 'ANNUALG'" class="row flex-column flex-md-row mb-3">
                          <div class="col-sm-6 col-md-5">
                            <p v-if="quote.COVERTYPE === 'BACKPACKER'" class="fw-bold">Add winter sports cover</p>
                            <p v-else class="fw-bold">Add winter sports cover</p>
                          </div>
                          <div class="col-10 col-sm-5 col-md-6 mb-3">
                            <div class="form-check">
                              <input v-if="quote.COVERTYPE === 'SINGLEG'"
                                class="form-check-input"
                                type="radio"
                                value="1"
                                v-model="winterSingle"
                                name="winter-radio"
                                id="select-winterS-y"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <input v-if="quote.COVERTYPE === 'BACKPACKER'"
                                class="form-check-input"
                                type="radio"
                                value="1"
                                v-model="winterBackpacker"
                                name="winter-radio"
                                id="select-winterS-y"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <label
                                class="form-check-label"
                                for="select-winterS-y"
                              >
                                Yes
                              </label>
                            </div>
                            <div class="form-check">
                              <input v-if="quote.COVERTYPE === 'SINGLEG'"
                                class="form-check-input"
                                type="radio"
                                value="0"
                                v-model="winterSingle"
                                name="winter-radio"
                                id="select-winterS-n"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <input v-if="quote.COVERTYPE === 'BACKPACKER'"
                                class="form-check-input"
                                type="radio"
                                value="0"
                                v-model="winterBackpacker"
                                name="winter-radio"
                                id="select-winterS-n"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <label
                                class="form-check-label"
                                for="select-winterS-n"
                              >
                                No
                              </label>
                            </div>
                          </div>
                          <div>
                            <winterSports-modal
                              :policy="defaultSite.policy"
                              :quoteType="tripDetails.quoteType"
                            >
                            </winterSports-modal>
                          </div>
                        </div>

                        <!-- MULTI WINTER SPORTS  -->
                        <div v-else class="row less-padding">
                          <div class="mb-3">
                            <small
                              >Winter sports cover automatically
                              <strong>included</strong></small
                            >
                          </div>
                        </div>

                       
                        <!-- CRUISE -->
                        <div class="row flex-column flex-md-row mb-3" v-if="quote.COVERTYPE !== 'BACKPACKER'">
                          <div class="col-sm-6 col-md-5">
                            <p class="fw-bold">Add cruise cover</p>
                          </div>
                          <div class="col-10 col-sm-5 col-md-6 mb-3">
                            <div class="form-check">
                              <input v-if="quote.COVERTYPE === 'SINGLEG'"
                                class="form-check-input"
                                type="radio"
                                value="1"
                                v-model="cruiseSingle"
                                name="cruise-r"
                                id="select-cruiseS-y"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <input v-if="quote.COVERTYPE === 'ANNUALG'"
                                class="form-check-input"
                                type="radio"
                                value="1"
                                v-model="cruiseAnnual"
                                name="cruise-r"
                                id="select-cruiseS-y"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <label
                                class="form-check-label"
                                for="select-cruiseS-y"
                              >
                                Yes
                              </label>
                            </div>
                            <div class="form-check">
                              <input v-if="quote.COVERTYPE === 'SINGLEG'"
                                class="form-check-input"
                                type="radio"
                                value="0"
                                v-model="cruiseSingle"
                                name="cruise-r"
                                id="select-cruiseS-n"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <input v-if="quote.COVERTYPE === 'ANNUALG'"
                                class="form-check-input"
                                type="radio"
                                value="0"
                                v-model="cruiseAnnual"
                                name="cruise-r"
                                id="select-cruiseS-n"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <label
                                class="form-check-label"
                                for="select-cruiseS-n"
                              >
                                No
                              </label>
                            </div>
                          </div>
                          <div>
                            <cruise-modal
                              :policy="defaultSite.policy"
                              :quoteType="tripDetails.quoteType"
                            >
                            </cruise-modal>
                          </div>
                        </div>

                        <!-----IRELAND SPECIFC--->
                        <div
                          class="row flex-column flex-md-row mb-3 justify-content-center"
                          v-if="defaultSite.domain === 'ie'"
                        >
                          <div class="col-12">
                            <small>
                              25% discount<br />if you have Private Health
                              insurance which provides overseas medical expenses
                              cover
                            </small>
                          </div>
                          <div class="col-12 mb-3 d-flex flex-column justify-content-center">
                            <div class="form-check mx-auto">
                              <input v-if="quote.COVERTYPE === 'SINGLEG'"
                                class="form-check-input"
                                type="radio"
                                value="1"
                                v-model="dubSingle"
                                name="25-r"
                                id="select-25-y"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <input v-if="quote.COVERTYPE === 'ANNUALG'"
                                class="form-check-input"
                                type="radio"
                                value="1"
                                v-model="dubAnnual"
                                name="25-r"
                                id="select-25-y"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <label class="form-check-label" for="select-25-y">
                                Yes
                              </label>
                            </div>
                            <div class="form-check mx-auto">
                              <input v-if="quote.COVERTYPE === 'SINGLEG'"
                                class="form-check-input"
                                type="radio"
                                value="0"
                                v-model="dubSingle"
                                name="25-r"
                                id="select-25-n"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <input v-if="quote.COVERTYPE === 'ANNUALG'"
                                class="form-check-input"
                                type="radio"
                                value="0"
                                v-model="dubAnnual"
                                name="25-r"
                                id="select-25-n"
                                @change="addExtras(quote.COVERTYPE)"
                              />
                              <label class="form-check-label" for="select-25-n">
                                No
                              </label>
                            </div>
                          </div>
                          <div>
                            <discount25-modal
                              :quoteType="tripDetails.quoteType"
                            >
                            </discount25-modal>
                          </div>
                        </div>
                        <!-----CAR HIRE-->
                        <div v-if="quote.COVERTYPE !== 'ANNUALG'"
                          class="row flex-column flex-md-row mb-3 justify-content-center"
                        >
                          <div class="col-10 col-sm-11 col-md-11 mb-3">
                            <small v-if="quote.COVERTYPE !== 'BACKPACKER'"
                              >
                              To top up your cancellation cover (over {{ cover.uk.cancellation }}pp),
                              add car hire damage excess waiver, or add gadget pack cover, please call 
                              us on 020 7408 9005.
                            </small>
                            <small v-else>
                              Call us to add Extended Cover for High Value Items and/or Car Hire Damage Excess Waiver.
                            </small>
                          </div>
                          <div>
                            <car-modal
                              :policy="defaultSite.policy"
                              :quoteType="tripDetails.quoteType"
                              :domain="defaultSite.domain"
                            >
                            </car-modal>
                          </div>
                        </div>
                        <div v-else class="row flex-column flex-md-row mb-3 justify-content-center">
                          <div class="col-10 col-sm-11 col-md-11 mb-3">
                            <small v-if="defaultSite.domain !== 'ie'">
                              To top up your cancellation cover (over {{ cover.uk.cancellation }}pp),
                              add car hire damage excess waiver, or add gadget pack cover, please call 
                              us on 020 7408 9005.
                            </small>
                          </div>
                          <div>
                            <car-modal
                              :policy="defaultSite.policy"
                              :quoteType="tripDetails.quoteType"
                              :domain="defaultSite.domain"
                            >
                            </car-modal>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <!-- /form -->
                  <div v-if="showBestSeller(quote)"
                        class="tf-vue-tag p-0 text-white container-fluid d-flex align-items-center justify-content-center">
                    <p class="text-center mb-0 p-0">Best Seller</p>
                  </div>
                  <div v-if="quote.COVERTYPE === tripDetails.quoteType" class="tf-vue-tag-selected p-0 text-white container-fluid d-flex align-items-center justify-content-center">
                    <p class="text-center mb-0 ps-1">Selected</p>
                  </div>

                </div>
            </div>
          </div>
        </section>

        <section v-else>
          <div class="text-center">
            <h3>Something went wrong with retrieving the insurance quotes. Call us on <a href="tel:02074089005" data-ga4-label="insurance" data-ga4-category="text_link">020 7408 9005</a></h3>
          </div>
        </section>  

<!--------------------------------->
  

          <div class="jumbotron my-5 border p-3">
            <h4 class="text-center fw-bold">Pre-Existing Medical Conditions</h4>
           
  
            <backpacker-medical-modal v-if="tripDetails.quoteType === 'BACKPACKER'"></backpacker-medical-modal>
            <p class="text-center fw-bold">
              If you would like to know if your pre-existing medical
              condition(s) can be covered and whether any optional additional
              premiums are payable prior to purchasing your Trailfinders Travel
              Insurance policy, please
              <a
                class="text-dark fw-bolder text-decoration-none"
                target="_blank"
                :href="
                  defaultSite.domain === 'ie'
                    ? 'https://policyscreening.com/trailfindersirl/'
                    : 'https://policyscreening.com/trailfinders/'
                "
              >
                <u>click here.</u>
              </a>
            </p>
            <p v-if="tripDetails.quoteType === 'BACKPACKER'" class="fw-bold text-center">
              Certain pre-existing medical conditions are automatically covered and you do not need to call the medical screening helpline.<br/> <a data-bs-toggle="modal" data-bs-target="#backpackerMedicalModal" class="text-decoration-underline text-dark hover">Click Here</a>
               to see the full list.
            </p>
          </div>
          <div class="jumbotron my-5 border p-3">
            <h4 class="text-center fw-bold">Cooling off Period</h4>
            <p class="text-center fw-bold">
              If for any reason you change your mind you can
              <strong
                >cancel within 21 days and we’ll refund you in full</strong
              >
              – no questions asked (providing travel has not commenced and you
              have not or do not intend to make a claim)
            </p>
          </div>
        </main>
      </div>

      <div class="col-12 col-md-4">
        <aside>
          <div class="card">
            <div class="tf-vue-bg-grey-dark flex-column text-center justify-content-center align-items-center p-3"
            >
              <div class="d-flex flex-column">
                                <div v-if="tripDetails.quoteType !== 'BACKPACKER'" class="float-end">
                  <img src="https://cdn.trailfinders.com/3dauu2dhtm_travel-insurance-rating-category-and-year-5-colour-rgb.png?width=100" alt="defaqto logo" class="float-lg-end mb-3 mb-xl-0" />
                </div>
                <div v-if="tripDetails.quoteType !== 'BACKPACKER'" class="summary-title">
                  <h2 class="fs-5">Summary of Cover</h2> 
                </div>
                <div v-else class="text-center">
                  <h2 class="fs-5">Summary of Cover</h2> 
                </div>

              </div>
              <h3 v-if="(tripDetails.quoteType === 'SINGLEG')">Trailfinders Single Trip policy</h3>
              <h3 v-if="(tripDetails.quoteType === 'ANNUALG')">Trailfinders Annual Multi-Trip policy</h3>
              <h3 v-if="(tripDetails.quoteType === 'BACKPACKER')">Trailfinders Backpacker policy</h3>
            </div>
            <div class="card-body tf-vue-bg-grey-light p-1 d-flex flex-column align-items-center">
              <ul v-if="(tripDetails.quoteType === 'SINGLEG')">
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.cancellation }}</span>
                  <span v-else>{{ cover.uk.cancellation }}</span>pp cancellation and curtailment cover.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.medical }}</span>
                  <span v-else>{{ cover.uk.medical }}</span> medical expenses with 365/24/7 emergency assistance.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.personalLiability }}</span>
                  <span v-else>{{ cover.uk.personalLiability }}</span> personal liability.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.personalAccident }}</span>
                  <span v-else>{{ cover.uk.personalAccident }}</span>pp personal accident.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.baggage }}</span>
                  <span v-else>{{ cover.uk.baggage }}</span>pp baggage cover.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.personalMoney }}</span>
                  <span v-else>{{ cover.uk.personalMoney }}</span>pp personal money cover.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.passportVisa }}</span>
                  <span v-else>{{ cover.uk.passportVisa }}</span>pp passport &amp; visa cover.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.travelDelay }}</span>
                  <span v-else>{{ cover.uk.travelDelay }}</span>pp travel delay cover.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.legalExpenses }}</span>
                  <span v-else>{{ cover.uk.legalExpenses }}</span>pp legal expenses.
                </li>
                <li>Wide range of sporting &amp; adventurous activities included.</li>
              </ul> 

              <ul v-if="(tripDetails.quoteType === 'ANNUALG')">
                <li>Same cover limits as the Trailfinders Single Trip policy.</li>
                <li>Unlimited number of trips, anywhere in the world.</li>
                <li>Up to 70 days cover on any one trip.</li>
                <li>28 days Winter Sports cover included free of charge.</li>
                <li>Insured partner/spouse and children covered even if travelling independently of one another.</li>
                <li>Business travel included.</li>
                <li>Wide range of sporting and adventurous activities included.</li>
              </ul>

              <ul v-if="(tripDetails.quoteType === 'BACKPACKER')">
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.cancellation }}</span>
                    <span v-else>{{ cover.ukBackpacker.cancellation }}</span>pp cancellation &amp; trip interruption cover.
                  </li>
                  <li>Up to 
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.medical }}</span>
                    <span v-else>{{ cover.ukBackpacker.medical }}</span> medical expenses with 365/24/7 emergency assistance and automatic cover for certain pre-existing medical conditions.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.personalLiability }}</span>
                    <span v-else>{{ cover.ukBackpacker.personalLiability }}</span> personal liability.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.personalAccident }}</span>
                    <span v-else>{{ cover.ukBackpacker.personalAccident }}</span>pp personal accident.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.baggage }}</span>
                    <span v-else>{{ cover.ukBackpacker.baggage }}</span>pp baggage cover.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.personalMoney }}</span>
                    <span v-else>{{ cover.ukBackpacker.personalMoney }}</span>pp personal money cover.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.passportVisa }}</span>
                    <span v-else>{{ cover.ukBackpacker.passportVisa }}</span>pp passport &amp; visa cover.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.travelDelay }}</span>
                    <span v-else>{{ cover.ukBackpacker.travelDelay }}</span>pp travel delay cover.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.legalExpenses }}</span>
                    <span v-else>{{ cover.ukBackpacker.legalExpenses }}</span> legal expenses.
                  </li>
                  <li>Wide range of sporting &amp; adventurous activities included.</li>
                  <li>Volunteering, working holidays* &amp; trekking to 7,000 metres included.</li>
                  <li>Temporary return home during the period of cover.</li>
                  <li>No need for proof of return flight.</li>
                  <li>Take out or extend cover whilst travelling.</li>
                  <small>* some exceptions apply.</small>
                </ul>
            </div>
          </div>

          <div id="quoteSummary" class="mt-3">
            <h2>Quote Summary</h2>
          <h6>
            Please make sure that you have provided the correct information
          </h6>
          <hr />
          <ul class="tf-vue-list-unstyled">
            <li>
              Country of residence:<strong class="ms-3">{{ tripDetails.residence }}</strong>
            </li>
            <li v-if="tripDetails.quoteType !== 'ANNUALG'">
              Travelling to:<strong class="ms-3">{{ tripDetails.destination }}</strong>
            </li>
            <li v-if="tripDetails.quoteType === 'ANNUALG'">
              Worldwide Cover:<strong class="ms-3">1 Year</strong>
            </li>
            <li v-if="tripDetails.quoteType !== 'ANNUALG'">
              From:<strong class="ms-3">{{ fromDate }}</strong>
            </li>
            <li v-if="tripDetails.quoteType !== 'ANNUALG'">
              To:<strong class="ms-3">{{ toDate }}</strong>
            </li>
            <li>
              <span class="col">Number of people:</span>
              <strong class="ms-3 row" v-html="tripDetails.numberPeopleString"></strong>
            </li>
            <li v-if="tripDetails.totalAdults === 2 && tripDetails.quoteType == 'ANNUALG'">
              <strong>Adults must be partners or spouse</strong>
            </li>
          </ul>
          <hr />
          <div v-if="tripDetails.quoteType !== 'BACKPACKER'">
          <p>
            <small>
              <strong>Please note:</strong> This policy offers cancellation
              cover of up to {{ cover.uk.cancellation }}pp. If you need to extend your cover beyond this please call us on 020 7408 9005.
            </small>
          </p>
        </div>
        <div v-else>
          <small>
            <strong>Please note:</strong> This policy offers cancellation cover of up to {{ cover.ukBackpacker.cancellation }}pp. If you need to extend your cover beyond this, additional cover can be purchased upon completion of your booking via a link on our online portal Viewtrail.
          </small>
        </div>
        </div>

        </aside>

        <div class="my-4 d-flex justify-content-center">
          <button class="btn btn-dark p-3 rounded-0 mt-0 w-100" @click="goBack">
            <i class="icon-arrow_left tf-orange me-2"></i>Go Back
          </button>
        </div>

        <div class="row flex-column p-3">
          <div class="border p-2">
            <a
              href="/insurance#/step1"
              type="button"
              class="text-dark text-decoration-none d-flex justify-content-center text-center"
            >
              Home Page
            </a>
          </div>
          <div class="border p-2">
            <a
              :href="tripDetails.quoteType === 'BACKPACKER'? '/travel-insurance/' + defaultSite.studentipid 
                                                            :'/travel-insurance/' + defaultSite.ipid"
              target="_blank"
              type="button"
              class="text-dark text-decoration-none d-flex justify-content-center text-center"
            >
              Insurance Product Information Document
            </a>
          </div>
          <div class="border p-2">
            <a
              :href="tripDetails.quoteType === 'BACKPACKER'? '/travel-insurance/' + defaultSite.studentpolicy
                                                            :'/travel-insurance/' + defaultSite.policy"
              target="_blank"
              type="button"
              class="text-dark text-decoration-none d-flex justify-content-center text-center"
            >
              Policy Document
            </a>
          </div>

          <div class="border p-2">
            <adventure-modal :quote="tripDetails.quoteType" > </adventure-modal>
          </div>
       
        </div>
      </div>
    </div>
  </section>
  <!-- /Container -->
</template>
<script>
import moment from "moment";
import { fetchQuote } from "@/services/api.js";
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { cover } from "../amounts/cover";

export default {
  
  props: ["defaultSite"],
  data() {
    return {
      showFamily: Boolean,
      modalSingleType: "SINGLEG",
      modalAnnualType: "MULTI",
      isActive: true,
      cover,
      backpackerAgeError : false,
      backpackerYoungAgeError : false,
      backpackerGroupSizeError : false,
      annualGroupSizeError : false,
      annualDurationError : false
    };
  },
  created() {
    if (!this.tripDetails.totalNumberOfPeople) {
      this.$router.push("/step1");
    }
    this.showFamily = this.showFamilyCondition;

    let tmp = []
      //first find out if we retrieved a price from sfacts for each premium and show the ones we did.
      this.quoteSingle.PREMIUM && Number(this.quoteSingle.PREMIUM) > 0 && tmp.push(this.quoteSingle)
      this.quoteAnnual.PREMIUM && Number(this.quoteAnnual.PREMIUM) > 0 && tmp.push(this.quoteAnnual)
      this.quoteBackpacker.PREMIUM && Number(this.quoteBackpacker.PREMIUM) > 0 && tmp.push(this.quoteBackpacker)

      if(this.quoteAnnual.PREMIUM === '0' || this.quoteAnnual.PREMIUM === 0){
        //handle annual quote errors
          //too many adults
          if( this.tripDetails.totalAdults > 2 ){
            this.annualGroupSizeError = true
            !tmp.includes(this.quoteAnnual) && tmp.push(this.quoteAnnual)
          }
          //handle above 70day duration
          if(this.durationDays > 70){
            this.annualDurationError = true
            !tmp.includes(this.quoteAnnual) && tmp.push(this.quoteAnnual)
          }
        
      }
      
      if(this.quoteBackpacker.PREMIUM === '0' && this.defaultSite.domain !== 'ie'){
        //handle backpacker quote errors
        for(let i=0; i < this.step1.peopleAges.length; i++){
          //too old 
          if(this.step1.peopleAges[i].AGE > 30){
            if(!this.backpackerAgeError)this.backpackerAgeError = true
            !tmp.includes(this.quoteBackpacker) && tmp.push(this.quoteBackpacker)
         }
         //too young
         if(this.step1.peopleAges[i].AGE < 14){
            if(!this.backpackerYoungAgeError)this.backpackerYoungAgeError = true
            !tmp.includes(this.quoteBackpacker) && tmp.push(this.quoteBackpacker)
         }
         // wrong group size
         if(this.step1.peopleAges.length > 2){
          if(!this.backpackerGroupSizeError)this.backpackerGroupSizeError = true
          !tmp.includes(this.quoteBackpacker) && tmp.push(this.quoteBackpacker)
         }

        }
      }
 
      //then reorder the array to show the selected quote first
      const swapPositions = (array, a, b) => {
        [array[a], array[b]] = [array[b], array[a]]
      }
      tmp.forEach((quote, index) => {
        if (this.tripDetails.quoteType === quote.COVERTYPE) {
          swapPositions(tmp, 0, index)
        }
      }) 
    tmp.length > 0 && this.changeSelectedQuote(tmp[0].COVERTYPE)
   
    this.showQuotes = tmp
  },
  computed: {
    ...mapFields({
      familySingle: "quoteSingle.FAMILYDISCOUNT",
      winterSingle: "quoteSingle.WINTERSPORT",
      cruiseSingle: "quoteSingle.CRUISE",
      dubSingle: "quoteSingle.DUBDISCOUNT",
      winterBackpacker: 'quoteBackpacker.WINTERSPORT',
      cruiseBackpacker: 'quoteBackpacker.CRUISE',
      cruiseAnnual: "quoteAnnual.CRUISE",
      dubAnnual: "quoteAnnual.DUBDISCOUNT",
    }),
    ...mapGetters({
      quoteSingle: "getQuoteSingle",
      quoteAnnual: "getQuoteAnnual",
      quoteBackpacker: 'getQuoteBackpacker',
      tripDetails: "getTripDetailsInfo",
      step1: "getStep1",
      fromDateRaw : "getFromDateRaw",
      toDateRaw : 'getToDateRaw'
    }),
    
    isKBInternal() {
      return process.env.VUE_APP_INTERNAL === "true" ? true : false;
    },
    showFamilyCondition() {
      // when to show family discount
      let showFamily = false;
      if (
        (this.tripDetails.quoteType === "SINGLEG" &&
          this.tripDetails.totalNumberOfPeople > 2 &&
          this.quoteSingle.CHILDREN > 1 &&
          this.quoteSingle.CHILDREN < 7) ||
        (this.tripDetails.quoteType === "ANNUALG" &&
          this.tripDetails.totalAdults > 1)
      ) {
        showFamily = true;
      }
      return showFamily;
    },
    durationDays() {
      return (
        moment(this.tripDetails.toDate, "YY-MM-DD").diff(
          moment(this.tripDetails.fromDate, "YY-MM-DDDD"),
          "days"
        ) + 1
      );
    },
    fromDate() {
      return moment(this.tripDetails.fromDate, "YY-MM-DD").format(
        "D MMMM YYYY"
      );
    },
    toDate() {
      return moment(this.tripDetails.toDate, "YY-MM-DD").format(
        "D MMMM YYYY"
      );
    },

    

    over90Days() {
      let over90 = false;
      const start = moment(this.tripDetails.fromDate, "YY-MM-DD");
      const now = moment();
      let daysDiff = start.diff(now, "days");
      if (daysDiff > 89) {
        over90 = true;
      }
      return over90;
    },
    overBackpackerAges() {
      let overBackpackerAge = false
      for(let i=0; i < this.step1.peopleAges.length; i++){
          if(this.step1.peopleAges[i].AGE > 30){
            overBackpackerAge = true
          } 
        }
        return overBackpackerAge
    }
   
  },
  mounted() {
    window.scroll({
      top: 0,
      behavior: "instant",
    });
    var element = document.getElementsByClassName("trustpilot-widget");
      for(var i=0; i<element.length; i++) {
      window.Trustpilot.loadFromElement(element[i]);
    }
  },

  methods: {
    
    ...mapActions([
      "updateQuoteSingle",
      "updateQuoteAnnual",
      "updateQuoteBackpacker",
      "fetchQuoteInfoSingle",
      "fetchQuoteInfoAnnual",
      "fetchQuoteInfoBackpacker",
      "updatePremiumSingle",
      "updatePremiumAnnual",
      "updatePremiumBackpacker",
      "updateQuoteType",
    ]),

    showBestSeller(quote) {
    if(quote.COVERTYPE === 'BACKPACKER' && Number(this.quoteBackpacker.PREMIUM > 0)) return true
    else if(quote.COVERTYPE === 'ANNUALG' && Number(this.quoteAnnual.PREMIUM > 0)){
     if( Number(this.quoteBackpacker.PREMIUM) > 0){
      return false
     } else {
      return true
     }
    }
    return false
    },
    
    async addExtras(quote) {
      if(quote === 'SINGLEG'){
        let res = await fetchQuote(this.quoteSingle);
        this.updateQuoteSingle(this.quoteSingle);
        this.fetchQuoteInfoSingle({ response: res });
        this.updatePremiumSingle(res.premium).catch(() => {
        this.quoteError = true;
      });
      }
      if(quote === 'ANNUALG'){
        let res = await fetchQuote(this.quoteAnnual);
        this.updateQuoteAnnual(this.quoteAnnual);
        this.fetchQuoteInfoAnnual({ response: res });
        this.updatePremiumAnnual(res.premium).catch(() => {
        this.quoteError = true;
      });
      }
      if(quote === 'BACKPACKER'){
        let res = await fetchQuote(this.quoteBackpacker);
        this.updateQuoteBackpacker(this.quoteBackpacker);
        this.fetchQuoteInfoBackpacker({ response: res });
        this.updatePremiumBackpacker(res.premium).catch(() => {
        this.quoteError = true;
      });
      }
    },

    changeSelectedQuote(quote) {
      this.updateQuoteType(quote)
    },

    // SUBMIT
    submitQuote(quote) {
     
      if(quote === 'SINGLEG') this.updateQuoteSingle(this.quoteSingle);
      if(quote === 'ANNUALG' ) {
        this.tripDetails.durationString = "12 Months";
        this.tripDetails.destination = "";
        this.updateQuoteAnnual(this.quoteAnnual);}
      if(quote === 'BACKPACKER') this.updateQuoteBackpacker(this.quoteBackpacker);
      this.updateQuoteType(quote)
      this.$router.push("/step3")
    },
    goBack() {
      this.$router.push("/");
    },
  },
};
</script>
<style scoped>
.over90 {
  font-size: 1rem;
  color: rgb(220, 52, 52);
}
</style>
